import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const VerifyHowTo = ({ reference }: { reference: string }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={theme => ({
        mt: 3,
        p: "16px 18px",
        borderRadius: "8px",
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.action.hover,
      })}
    >
      <Typography
        sx={theme => ({
          fontSize: "13.5px",
          lineHeight: 1.6,
          color: theme.palette.text.secondary,
        })}
      >
        <strong>{t("verify.howto.heading")}</strong>{" "}
        {t("verify.howto.body", { reference })}
      </Typography>
    </Box>
  );
};

export default VerifyHowTo;
